import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from './ui/layout/AppShell';
import { DayView } from './ui/views/DayView';
import { WeekView } from './ui/views/WeekView';
import { MonthView } from './ui/views/MonthView';
import { SearchView } from './ui/views/SearchView';
import { GoalsView } from './ui/views/GoalsView';
import { ReportsView, TaskReportView } from './ui/views/ReportsView';
import { ProjectDetailView, ProjectsView } from './ui/views/ProjectsView';
import { SettingsView } from './ui/views/SettingsView';
import { EntryDetail } from './ui/views/EntryDetail';
import { EntryEdit } from './ui/views/EntryEdit';
import { toDateKey } from './lib/datetime';

/** ルーティング（仕様書 §12.2）。 */
export const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      { path: '/', element: <Navigate to={`/day/${toDateKey(new Date())}`} replace /> },
      { path: '/day/:date', element: <DayView /> },
      { path: '/week/:week', element: <WeekView /> },
      { path: '/month/:month', element: <MonthView /> },
      { path: '/goals', element: <GoalsView /> },
      { path: '/projects', element: <ProjectsView /> },
      { path: '/projects/:projectId', element: <ProjectDetailView /> },
      { path: '/reports', element: <ReportsView /> },
      { path: '/reports/:taskId', element: <TaskReportView /> },
      { path: '/search', element: <SearchView /> },
      { path: '/settings', element: <SettingsView /> },
      { path: '/entry/:id', element: <EntryDetail /> },
      { path: '/entry/:id/edit', element: <EntryEdit /> },
      { path: '/new', element: <EntryEdit /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
